import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function WRBotox() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px] overflow-hidden" data-id="element-2288">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-2289">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-2290">
          {/* Left Column - Text */}
          <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-2291">
            <span className="text-[#FF1493] uppercase text-[13px] font-bold tracking-[2px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-2292">
              TREATMENT OPTION
            </span>

            <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-8 font-[600] font-[Poppins,_sans-serif]" data-id="element-2293">
              WHAT IS BOTOX?
            </h2>

            <div className="space-y-6 text-[#333333] text-base leading-[1.8] font-body" data-id="element-2294">
              <p data-id="element-2295">
                Botox, short for botulinum toxin, is a neurotoxic protein
                produced by the bacterium Clostridium botulinum. It is widely
                used to reduce the appearance of facial wrinkles. Botox by
                Allergan works by temporarily blocking nerve signals in the
                muscles where it is injected, preventing them from contracting.
                As a result, it helps to smooth out wrinkles and lines caused by
                repetitive facial expressions like frowning or squinting.
              </p>
              <p data-id="element-2296">
                Botox injections reduce muscle contractions by blocking the
                signals from nerves to muscles. When the injected muscles aren't
                able to contract as tightly, the skin relaxes and softens,
                improving the wrinkle. Botox can also prevent new wrinkles from
                forming and is used as a preventative treatment in younger
                populations but it can also help existing wrinkles from
                deepening and worsening.
              </p>
            </div>
          </AnimateOnScroll>

          {/* Right Column - Image */}
          <AnimateOnScroll className="w-full lg:w-[45%]" delay={200} data-id="element-2297">
            <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden shadow-xl" data-id="element-2298">
              <img src="https://cdn.magicpatterns.com/uploads/acMaJJmcvowTif145bZ4Zj/beclinical-fillers_(1).jpg" alt="Be CLINICAL Staff - Botox Treatment" className="w-full h-full object-cover" data-id="element-2299" />
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}